import { MYSQL_FUNCTION } from '@/components/editor/snippets/functions/mysql';
import { PG_FUNCTION } from '@/components/editor/snippets/functions/pg';

export const functions = {
  MySQL: MYSQL_FUNCTION,
  PostgreSQL: PG_FUNCTION
};
export const getFunction = (dsType) => functions[dsType] || [];
